import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};

export const ContentStepperTwo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 650px;
  width: 100%;
`;

export const TextHeaderWrapper = styled.div`
  text-align: center;
  padding-bottom: 32px;
  max-width: 493px;
`;

export const ContentModal = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  background: ${BaSeTheme.colors.defaultColors.white};
  border: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae90};
  gap: 16px;
  padding-bottom: 8px;
  width: 100%;

  ${handleQuery(`
   width: 90%;
  `)}
`;

export const WrapperFields = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 24px 0px 24px;
  gap: 16px;
`;

export const WrapperTextDataOther = styled.div`
  margin-bottom: 10px;
`;

export const WrapperFieldsGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  ${handleQuery(`
    flex-direction: column;
    gap: 16px;
  `)}
`;

export const ContentText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 0px;
  padding-left: 24px;
  padding-bottom: 8px;
`;

export const TextWrapper = styled.div`
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 12px;
`;

export const RadioWrapper = styled.div`
  padding-top: 8px;
  padding-right: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ButtonConfirmWrapper = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  /* ${() =>
    css`
      .BaSe--button {
        border: 1px solid #bf303c;
      }
    `} */
`;
